import * as dates from "common/dates";

export const getPriorSubmissionId = (submission) => {
  const priorFilename =
    submission?.state?.input?.program?.priorSubmission ||
    submission?.priorSubmission;
  if (!priorFilename) return null;
  return priorFilename.endsWith(".json")
    ? priorFilename.replace(/\.json$/i, "")
    : priorFilename;
};

const MODIFIED_FIELDS = [
  "insuredName",
  "group",
  "effectiveDate",
  "ulLimitMillions",
  "ueGlxPremiumPreviousYear",
  "ueEllPremiumPreviousYear",
  "ueGlxPremiumCurrentYear",
  "ueEllPremiumCurrentYear",
  "munichPpmRelativeToUl",
  "evanstonPpmRelativeToUl",
  "munichBoundPremiumPreviousYear",
  "evanstonBoundPremiumPreviousYear",
  "arkTotalPremium",
];
const rowHasChanges = (row, original, fields) =>
  fields.some((field) => row[field] !== original[field]);

const getModifiedRows = (rows, originalRows) =>
  rows.filter((row) => {
    const original = originalRows.find((r) => r.id === row.id);
    return original && rowHasChanges(row, original, MODIFIED_FIELDS);
  });

const normalizeEffectiveDate = (effectiveDate) =>
  dates.parseDateStringFromDateOrYear(effectiveDate, {
    allowLocalFormats: true,
    defaultReturn: null,
  });

const buildCauseFormDataFromRow = (row) => ({
  insuredName: row.insuredName || "",
  reference: row.group || "",
  effectiveDate: normalizeEffectiveDate(row.effectiveDate),
  ulLimitMillions: row.ulLimitMillions,
  ueGlxPremiumPreviousYear: row.ueGlxPremiumPreviousYear,
  ueEllPremiumPreviousYear: row.ueEllPremiumPreviousYear,
  ueGlxPremiumCurrentYear: row.ueGlxPremiumCurrentYear,
  ueEllPremiumCurrentYear: row.ueEllPremiumCurrentYear,
  munichBoundPremiumPreviousYear: row.munichBoundPremiumPreviousYear,
  evanstonBoundPremiumPreviousYear: row.evanstonBoundPremiumPreviousYear,
  munichPpmRelativeToUl: row.munichPpmRelativeToUl,
  evanstonPpmRelativeToUl: row.evanstonPpmRelativeToUl,
  arkTotalPremiumCurrentYear: row.arkTotalPremium,
});

export const saveCauseWorkbookChanges = async ({
  rows,
  originalRows,
  retrieveSubmission,
  updateProgramSubmission,
  refetchSubmissions,
}) => {
  const modifiedRows = getModifiedRows(rows, originalRows);

  for (const row of modifiedRows) {
    const submission = await retrieveSubmission({
      submissionId: row.id,
    }).unwrap();

    const priorSubmissionId = getPriorSubmissionId(submission);
    await updateProgramSubmission({
      program: "CAUSE",
      formData: buildCauseFormDataFromRow(row),
      updateFilename: row.id,
      priorSubmissionFilename: priorSubmissionId || undefined,
    }).unwrap();
  }

  await refetchSubmissions();
};
